var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notice"},[_c('app-icon',{staticClass:"notice-icon",attrs:{"icon":"notice"}}),_c('div',{staticClass:"notice-text"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }